import { createTheme } from '@mui/material';
const BASE_IMG_URL = window._env_.REACT_APP_BASE_IMG_URL;
// Accede a las variables de CSS
const colorPrimary = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim();
const colorSecondaryDarkPurple = getComputedStyle(document.documentElement).getPropertyValue('--color-secondary-dark-purple').trim();
const colorSecondaryOrange = getComputedStyle(document.documentElement).getPropertyValue('--color-secondary-orange').trim();
const colorSecondaryCream = getComputedStyle(document.documentElement).getPropertyValue('--color-secondary-cream').trim();
const colorDisabled = getComputedStyle(document.documentElement).getPropertyValue('--color-disabled').trim();
const secondaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-secondary').trim();
const colorBtnEnabled = getComputedStyle(document.documentElement).getPropertyValue('--color-btn-enabled').trim();
const colorBtnHover = getComputedStyle(document.documentElement).getPropertyValue('--color-btn-hover').trim();
const colorBtnFocused = getComputedStyle(document.documentElement).getPropertyValue('--color-btn-focused').trim();
const colorBtnDisabled = getComputedStyle(document.documentElement).getPropertyValue('--color-btn-disabled').trim();
const textColorNormal = getComputedStyle(document.documentElement).getPropertyValue('--font-color-normal-text').trim();
const textColorCream = getComputedStyle(document.documentElement).getPropertyValue('--font-color-cream').trim();
const textColorPurple = getComputedStyle(document.documentElement).getPropertyValue('--font-color-purple').trim();
// Fuentes new branding:
const mainFont = getComputedStyle(document.documentElement).getPropertyValue('--main-font').trim();
const secondaryFont = getComputedStyle(document.documentElement).getPropertyValue('--secondary-font').trim();
// Función que crea el tema dinámicamente a partir de las variables CSS
export const createDynamicTheme = () => {
    /* Colores */
    // const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim();
    // const secondaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-secondary').trim();
    // const fontPrimaryColor = getComputedStyle(document.documentElement).getPropertyValue('--font-color-primary').trim();
    // const fontSecondaryColor = getComputedStyle(document.documentElement).getPropertyValue('--font-color-secondary').trim();
    /* Fuentes */
    // const mainFont = getComputedStyle(document.documentElement).getPropertyValue('--main-font').trim();
    // const secondaryFont = getComputedStyle(document.documentElement).getPropertyValue('--secondary-font').trim();
    //variable para ruta imagenes en scss
    document.documentElement.style.setProperty('--bg-login-url', `url(${BASE_IMG_URL}bg_login.jpg)`);
    return createTheme({
        cssVariables: true,
        palette: {
            primary: {
                main: colorPrimary,
            },
        },
        customImages: {
            logo: '/assets/images/Logo_Signo.png',
        },
        breakpoints: {
            values: {
                xs: 0,
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1200,
                xxl: 1400,
                /*
                xs: 0,
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1200,
                xxl: 1400,
                */
            },
        },
        typography: {
            fontFamily: mainFont || 'Roboto, sans-serif',
            h1: {
                fontSize: '3rem',
                fontWeight: 500,
                color: textColorNormal,
            },
            h2: {
                fontSize: '16px',
                fontWeight: 500,
                color: textColorNormal,
            },
            body1: {
                fontFamily: secondaryFont || 'Arial, sans-serif',
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontFamily: mainFont,
                        fontSize: '1rem',
                        lineHeight: '1.5rem !important',
                        fontWeight: 700,
                        borderRadius: '24px',
                        paddingLeft: '20px',
                        paddingRight: '20px',
                        minWidth: '180px',
                    },
                    // VARIANTE CONTAINED
                    contained: {
                        backgroundColor: colorBtnEnabled,
                        color: colorSecondaryCream,
                        '&:hover': {
                            backgroundColor: colorBtnHover,
                        },
                        '&:focus': {
                            backgroundColor: colorBtnFocused,
                        },
                        '&.Mui-disabled': {
                            backgroundColor: colorBtnDisabled,
                        },
                    },
                    // VARIANTE OUTLINED
                    outlined: {
                        border: `1px solid ${colorBtnEnabled}`,
                        color: colorBtnEnabled,
                        backgroundColor: 'transparent',
                        '&:hover': {
                            borderColor: colorBtnHover,
                            color: colorSecondaryCream,
                            backgroundColor: colorBtnHover,
                        },
                        '&:focus': {
                            borderColor: colorBtnFocused,
                            color: colorSecondaryCream,
                            backgroundColor: colorBtnHover,
                        },
                        '&.Mui-disabled': {
                            borderColor: colorBtnDisabled,
                            color: colorBtnDisabled,
                        },
                    },
                    // VARIANTE TEXT
                    text: {
                        color: colorBtnEnabled,
                        backgroundColor: 'transparent',
                        '&:hover': {
                            color: colorBtnHover,
                        },
                        '&:focus': {
                            color: colorBtnFocused,
                        },
                        '&.Mui-disabled': {
                            color: colorBtnDisabled,
                        },
                    },
                },
            },
            MuiRadio: {
                styleOverrides: {
                    root: {
                        color: textColorNormal,
                        '&.Mui-checked': {
                            color: colorPrimary, // color cuando está seleccionado
                        },
                        '&.Mui-disabled': {
                            color: colorDisabled,
                        },
                    },
                },
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        color: colorPrimary,
                    },
                },
            },
            MuiToggleButton: {
                styleOverrides: {
                    root: {
                        fontFamily: secondaryFont,
                        fontSize: '1rem',
                        fontWeight: '400',
                        backgroundColor: '#FFF',
                        color: textColorNormal,
                        margin: '0 !important',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                        '&.Mui-selected': {
                            backgroundColor: `${colorPrimary} !important`,
                            color: `${textColorCream} !important`,
                            '&:hover': {
                                backgroundColor: colorBtnHover,
                            },
                        },
                        '&.Mui-disabled': {
                            backgroundColor: colorBtnDisabled,
                            color: textColorCream,
                        },
                    },
                },
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        whiteSpace: 'normal !important',
                        height: 'auto',
                    },
                },
            },
            MuiSwitch: {
                styleOverrides: {
                    root: {
                        '& .MuiSwitch-thumb': {
                            backgroundColor: textColorNormal, // thumb por defecto crema
                        },
                        '& .Mui-checked .MuiSwitch-thumb': {
                            backgroundColor: `${colorPrimary} !important`, // color del thumb activado
                        },
                        '& .Mui-checked + .MuiSwitch-track': {
                            backgroundColor: `${colorPrimary} !important`,
                            opacity: 1,
                        },
                        '& .MuiSwitch-track': {
                            backgroundColor: 'rgba(0, 0, 0, 0.25)', // color de pista desactivado
                        },
                        '&.Mui-disabled .MuiSwitch-thumb': {
                            backgroundColor: colorBtnDisabled, // color del thumb desactivado
                        },
                        '&.Mui-disabled + .MuiSwitch-track': {
                            backgroundColor: 'rgba(0, 0, 0, 0.1)', // color de pista desactivada
                        },
                    },
                },
            },
            MuiCheckbox: {
                styleOverrides: {
                    root: {
                        color: textColorNormal,
                        '&.Mui-checked svg': {
                            fill: colorPrimary,
                            color: colorPrimary,
                        },
                    },
                },
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        fontSize: '1rem',
                        fontWeight: '500',
                        color: textColorNormal,
                        '&.Mui-focused': {
                            color: textColorNormal, // sobrescribe el color morado por el que tú quieras
                        },
                    },
                },
            },
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        //position: 'absolute',
                        //bottom: '-20px',
                        fontSize: '0.75rem',
                        fontFamily: secondaryFont || 'Roboto, sans-serif',
                        margin: 0,
                    },
                },
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        maxHeight: '42px',
                        color: textColorNormal,
                        fontFamily: secondaryFont || 'Roboto, sans-serif',
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        color: colorSecondaryDarkPurple,
                        borderRadius: '24px',
                        fontSize: '1rem',
                        backgroundColor: 'white',
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: colorSecondaryDarkPurple,
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: colorSecondaryDarkPurple,
                            color: colorSecondaryDarkPurple,
                        },
                    },
                    notchedOutline: {
                        borderColor: colorSecondaryDarkPurple,
                        borderWidth: '1px',
                    },
                    input: {
                        height: '100%',
                        boxSizing: 'border-box',
                        color: colorSecondaryDarkPurple,
                        '&:-webkit-autofill': {
                            WebkitBoxShadow: '0 0 0 100px transparent inset !important',
                            WebkitTextFillColor: `${textColorNormal} !important`,
                            caretColor: `${textColorNormal} !important`,
                        },
                        '&:-internal-autofill-selected': {
                            appearance: 'none !important',
                            backgroundImage: 'none !important',
                            backgroundColor: 'transparent !important',
                            color: `${textColorNormal} !important`,
                        },
                    },
                },
            },
            MuiAccordion: {
                styleOverrides: {
                    root: ({ theme }) => ({
                        boxShadow: 'none',
                        border: 'none',
                        '&:before': { display: 'none' },
                        '&.Mui-expanded': { margin: '0px' },
                    }),
                },
            },
            MuiStepConnector: {
                styleOverrides: {
                    alternativeLabel: {
                        top: 12, // alinea la línea con el centro del icono
                    },
                    line: {
                        height: 4,
                        border: 0,
                        backgroundColor: 'var(--color-grey-500)',
                        borderRadius: 1,
                    },
                    root: {
                        '&.Mui-active .MuiStepConnector-line, &.Mui-completed .MuiStepConnector-line': {
                            backgroundColor: colorPrimary,
                        },
                    },
                },
            },
            MuiStepIcon: {
                styleOverrides: {
                    root: {
                        width: 24,
                        height: 24,
                        fontSize: '1rem',
                        color: 'var(--color-grey-500)',
                        '&.Mui-active': {
                            color: colorPrimary,
                        },
                        '&.Mui-completed': {
                            color: colorPrimary,
                        },
                    },
                    text: {
                        fontSize: '1rem',
                    },
                },
            },
            MuiStepLabel: {
                styleOverrides: {
                    label: {
                        marginTop: '10px !important',
                        fontSize: '0.875rem',
                        fontWeight: 400,
                    },
                },
            },
            MuiTabs: {
                styleOverrides: {
                    indicator: {
                        backgroundColor: colorPrimary, // Cambiá esto por tu color deseado
                    },
                },
            },
        },
    });
};
// Exporta un tema inicial (se usa para inicializar)
const themeDefault = createDynamicTheme();
export default themeDefault;
